export enum ETrialModalActions {
  HIDE_MODAL = 'trialModal/HIDE_MODAL',
  SHOW_MODAL = 'trialModal/SHOW_MODAL',
  SET_TIMER = 'trialModal/SET_TIMER',
  CLEAR_TIMER = 'trialModal/CLEAR_TIMER'
}
